{
  "planning.tab": "Plan",
  "planning.save": "Save",
  "planning.saving": "Saving…",
  "planning.loadError": "We could not load the plan.",
  "planning.phase.default.strategy": "Strategy",
  "planning.phase.default.design": "Design",
  "planning.phase.default.build": "Build",
  "planning.phase.default.grow": "Grow",
  "planning.phase.status.upcoming": "Upcoming",
  "planning.phase.status.active": "In progress",
  "planning.phase.status.done": "Done",
  "planning.phase.status.late": "Late",
  "planning.milestone.status.upcoming": "Upcoming",
  "planning.milestone.status.active": "In progress",
  "planning.milestone.status.late": "Late",
  "planning.milestone.status.done": "Reached",
  "planning.dates": "{start} – {end}",
  "planning.due.inDays": "{count, plural, =0 {Due today} one {Due tomorrow} other {Due in # days}}",
  "planning.due.lateBy": "{count, plural, one {# day late} other {# days late}}",
  "planning.due.reachedOn": "Reached {date}",
  "planning.due.startsIn": "{count, plural, =0 {Starts today} one {Starts tomorrow} other {Starts in # days}}",
  "planning.summary.label": "Plan at a glance",
  "planning.summary.currentMilestone": "Current milestone",
  "planning.summary.allReached": "Every milestone is reached",
  "planning.summary.inPhase": "Phase: {name}",
  "planning.summary.day": "Day {count, number} of {total, number}",
  "planning.summary.nextMilestone": "Next milestone",
  "planning.summary.noNextMilestone": "No upcoming milestone",
  "planning.summary.late": "Late milestones",
  "planning.summary.lateNone": "Nothing is late",
  "planning.timeline.title": "Timeline",
  "planning.timeline.label": "The project's milestones and phases in time",
  "planning.timeline.today": "Today",
  "planning.timeline.end": "End",
  "planning.timeline.endLabel": "The project ends {date}",
  "planning.timeline.milestones": "Milestones",
  "planning.timeline.legendDue": "Milestone due",
  "planning.timeline.noDates": "Not dated yet",
  "planning.timeline.duration": "{count, plural, one {# day} other {# days}}",
  "planning.timeline.overran": "{count, plural, one {# day over} other {# days over}}",
  "planning.timeline.addOn": "New milestone starting {date}",
  "planning.timeline.milestoneLabel": "{name}: {date}, {status}",
  "planning.phases.list": "Phases of {name}",
  "planning.phases.edit": "Edit {name}",
  "planning.phases.moveUp": "Move {name} earlier",
  "planning.phases.moveDown": "Move {name} later",
  "planning.phases.noDates": "No dates",
  "planning.phases.from": "From {date}",
  "planning.phases.until": "Until {date}",
  "planning.phases.outside": "Outside the milestone's dates ({start} – {end})",
  "planning.phases.progressLabel": "Tasks done in {name}",
  "planning.phases.empty": "Split this milestone into phases, or start from the agency's four: Strategy, Design, Build and Grow.",
  "planning.phases.emptyReadOnly": "This milestone has no phases.",
  "planning.phases.addDefaults": "Add default phases",
  "planning.phases.addingDefaults": "Adding…",
  "planning.phases.defaultsAdded": "The four phases are added.",
  "planning.phases.defaultsExist": "This milestone already has phases.",
  "planning.phases.add": "Add phase",
  "planning.phases.delete": "Delete {name}",
  "planning.phases.deleteTitle": "Delete the phase “{name}”?",
  "planning.phases.deleteBody": "Its tasks stay on the milestone, without a phase.",
  "planning.phases.deleteConfirm": "Delete phase",
  "planning.phases.deleted": "Phase deleted.",
  "planning.phases.saved": "Phase saved.",
  "planning.phaseDialog.newTitle": "New phase",
  "planning.phaseDialog.editTitle": "Edit phase",
  "planning.phaseDialog.name": "Name",
  "planning.phaseDialog.namePlaceholder": "Discovery",
  "planning.phaseDialog.startsOn": "Starts",
  "planning.phaseDialog.endsOn": "Ends",
  "planning.phaseDialog.datesHint": "Dates are optional; you can set them later.",
  "planning.phaseDialog.endBeforeStart": "The end is before the start.",
  "planning.phaseDialog.outside": "These dates fall outside {name} ({start} – {end}). You can still save them.",
  "planning.phaseDialog.create": "Add phase",
  "planning.phaseDialog.created": "Phase added.",
  "planning.phaseDialog.errors.name": "Give the phase a name.",
  "planning.milestones.title": "Milestones",
  "planning.milestones.new": "New milestone",
  "planning.milestones.empty.title": "No milestones yet",
  "planning.milestones.empty.body": "A milestone is a stretch of work with a start and an end, such as a sign-off, a beta or a launch. Split each one into phases.",
  "planning.milestones.empty.readOnly": "The project lead plans the milestones here.",
  "planning.milestones.complete": "Mark {name} as reached",
  "planning.milestones.reopen": "Reopen {name}",
  "planning.milestones.completed": "“{name}” is reached.",
  "planning.milestones.reopened": "“{name}” is open again.",
  "planning.milestones.menu": "More for {name}",
  "planning.milestones.edit": "Edit",
  "planning.milestones.viewTasks": "View tasks",
  "planning.milestones.delete": "Delete",
  "planning.milestones.tasks": "{total, plural, =0 {No tasks yet} one {{done, number} of # task done} other {{done, number} of # tasks done}}",
  "planning.milestones.phaseCount": "{count, plural, =0 {No phases} one {# phase} other {# phases}}",
  "planning.milestones.progressLabel": "Tasks done for {name}",
  "planning.milestones.deleteTitle": "Delete “{name}”?",
  "planning.milestones.deleteBody": "Its phases are deleted with it. Its tasks stay in the project, without a milestone.",
  "planning.milestones.deleteConfirm": "Delete milestone",
  "planning.milestones.deleting": "Deleting…",
  "planning.milestones.deleted": "Milestone deleted.",
  "planning.milestoneDialog.newTitle": "New milestone",
  "planning.milestoneDialog.editTitle": "Edit milestone",
  "planning.milestoneDialog.name": "Name",
  "planning.milestoneDialog.namePlaceholder": "Beta launch",
  "planning.milestoneDialog.startsOn": "Starts",
  "planning.milestoneDialog.dueOn": "Ends",
  "planning.milestoneDialog.description": "Notes",
  "planning.milestoneDialog.descriptionPlaceholder": "What counts as reaching it?",
  "planning.milestoneDialog.create": "Add milestone",
  "planning.milestoneDialog.created": "Milestone added.",
  "planning.milestoneDialog.saved": "Milestone saved.",
  "planning.milestoneDialog.errors.name": "Give the milestone a name.",
  "planning.milestoneDialog.errors.startsOn": "Pick its start date.",
  "planning.milestoneDialog.errors.dueOn": "Pick its end date.",
  "planning.milestoneDialog.errors.dueBeforeStart": "The end is before the start.",
  "planning.labels.title": "Labels",
  "planning.labels.new": "New label",
  "planning.labels.empty": "No labels yet. Labels group tasks across columns, like “Copy” or “Blocked”.",
  "planning.labels.edit": "Edit {name}",
  "planning.labels.delete": "Delete {name}",
  "planning.labels.deleteTitle": "Delete the label “{name}”?",
  "planning.labels.deleteBody": "It comes off every task that carries it.",
  "planning.labels.deleteConfirm": "Delete label",
  "planning.labels.deleted": "Label deleted.",
  "planning.labelDialog.newTitle": "New label",
  "planning.labelDialog.editTitle": "Edit label",
  "planning.labelDialog.name": "Name",
  "planning.labelDialog.namePlaceholder": "Copy",
  "planning.labelDialog.color": "Colour",
  "planning.labelDialog.create": "Add label",
  "planning.labelDialog.saved": "Label saved.",
  "planning.labelDialog.errors.name": "Give the label a name.",
  "planning.labelDialog.errors.taken": "This project already has a label with that name.",
  "planning.label.color.sage": "Sage",
  "planning.label.color.blue": "Blue",
  "planning.label.color.violet": "Violet",
  "planning.label.color.amber": "Amber",
  "planning.label.color.rose": "Rose",
  "planning.label.color.teal": "Teal",
  "planning.label.color.slate": "Slate",
  "planning.task.milestone": "Milestone",
  "planning.task.noMilestone": "No milestone",
  "planning.task.milestoneSearch": "Search milestones",
  "planning.task.noMilestoneMatch": "No milestone matches.",
  "planning.task.labels": "Labels",
  "planning.task.noLabels": "No labels",
  "planning.task.editLabels": "Edit labels",
  "planning.task.labelSearch": "Search or create a label",
  "planning.task.labelSearchOnly": "Search labels",
  "planning.task.createLabel": "Create “{name}”",
  "planning.task.noLabelMatch": "No label matches.",
  "planning.task.labelCreated": "Label “{name}” created.",
  "planning.subtasks.title": "Subtasks",
  "planning.subtasks.progressLabel": "{total, plural, one {{done, number} of # subtask done} other {{done, number} of # subtasks done}}",
  "planning.subtasks.empty": "Break the task into steps anyone can tick off.",
  "planning.subtasks.add": "Add subtask",
  "planning.subtasks.addPlaceholder": "Subtask title",
  "planning.subtasks.addHint": "Enter to add · Esc to close",
  "planning.subtasks.addError": "The subtask was not added. Try again.",
  "planning.subtasks.markDone": "Mark “{title}” as done",
  "planning.subtasks.markOpen": "Mark “{title}” as not done",
  "planning.subtasks.loadError": "We could not load the subtasks.",
  "planning.subtasks.parent": "Subtask of {reference}",
  "planning.board.toolbar": "Board view",
  "planning.board.showSubtasks": "Subtasks",
  "planning.board.labelFilter": "Filter by label",
  "planning.board.anyLabel": "All labels",
  "planning.board.hiddenByFilter": "{count, plural, one {# task hidden by the filter} other {# tasks hidden by the filter}}",
  "planning.card.subtasks": "{done, number}/{total, number}",
  "planning.card.moreLabels": "{count, plural, one {# more label} other {# more labels}}",
  "planning.card.subtaskOf": "Subtask of {reference}",
  "planning.list.labelFilter": "Filter by label",
  "planning.list.anyLabel": "Any label",
  "planning.list.milestoneFilter": "Filter by milestone",
  "planning.list.anyMilestone": "Any milestone",
  "planning.list.noMilestone": "No milestone",
  "planning.list.expand": "Show the subtasks of {reference}",
  "planning.list.collapse": "Hide the subtasks of {reference}",
  "planning.overview.title": "Milestones & phases",
  "planning.overview.open": "Open the plan",
  "planning.overview.current": "Now",
  "planning.overview.next": "Next",
  "planning.overview.late": "Late",
  "planning.overview.noMilestones": "No milestones planned yet.",
  "planning.dependencies.title": "Dependencies",
  "planning.dependencies.blockedBy": "Blocked by",
  "planning.dependencies.blocking": "Blocking",
  "planning.dependencies.hidden": "A task you cannot open",
  "planning.dependencies.blockedSummary": "{count, plural, one {Blocked by # open task} other {Blocked by # open tasks}}",
  "planning.dependencies.ready": "Ready: everything it waits for is done",
  "planning.dependencies.emptyBlockedBy": "Nothing to wait for. Add what has to be done first.",
  "planning.dependencies.emptyBlocking": "No task waits for this one.",
  "planning.dependencies.add": "Add a blocker",
  "planning.dependencies.search": "Search this project's tasks",
  "planning.dependencies.searching": "Searching…",
  "planning.dependencies.noMatch": "No task matches.",
  "planning.dependencies.remove": "Remove the link with {reference}",
  "planning.dependencies.cycle": "{reference} already waits for this task, directly or through other tasks, so it cannot block it.",
  "planning.dependencies.addError": "We could not link the tasks. Try again.",
  "planning.dependencies.removeError": "We could not remove the link. Try again.",
  "planning.dependencies.loadError": "We could not load the dependencies.",
  "planning.dependencies.stillBlocked": "{reference} is still waiting for {blockers}",
  "planning.dependencies.stillBlockedCount": "{reference} is still waiting for {count, plural, one {# open task} other {# open tasks}}",
  "planning.dependencies.warnOnly": "It moved anyway: a dependency is a reminder, not a lock.",
  "planning.card.blocked": "{count, plural, one {Blocked by # open task} other {Blocked by # open tasks}}",
  "planning.card.repeats": "Repeats: {rule}",
  "planning.list.blocked": "Blocked",
  "planning.list.blockedFilter": "Only blocked tasks",
  "planning.repeat.label": "Repeat",
  "planning.repeat.none": "Doesn't repeat",
  "planning.repeat.next": "Next: {date}",
  "planning.repeat.choose": "How often",
  "planning.repeat.custom": "Custom…",
  "planning.repeat.stop": "Don't repeat",
  "planning.repeat.saveError": "We could not save the repeat. Try again.",
  "planning.repeat.conflict": "Someone else changed this repeat. It has been reloaded.",
  "planning.repeat.everyWorkday": "Every workday",
  "planning.repeat.daily": "{interval, plural, one {Every day} other {Every # days}}",
  "planning.repeat.weeklyEvery": "Every {weekdays}",
  "planning.repeat.weekly": "{interval, plural, one {Every week on {weekdays}} other {Every # weeks on {weekdays}}}",
  "planning.repeat.monthly": "{interval, plural, one {Every month on day {day}} other {Every # months on day {day}}}",
  "planning.repeat.monthlyLast": "{interval, plural, one {Every month on its last day} other {Every # months on the last day}}",
  "planning.repeat.offWeekends": "{rule}, moving weekends to Sunday",
  "planning.repeat.until": "{rule}, until {date}",
  "planning.repeat.times": "{rule}, {count, plural, one {once} other {# times}}",
  "planning.repeat.day.0": "Sunday",
  "planning.repeat.day.1": "Monday",
  "planning.repeat.day.2": "Tuesday",
  "planning.repeat.day.3": "Wednesday",
  "planning.repeat.day.4": "Thursday",
  "planning.repeat.day.5": "Friday",
  "planning.repeat.day.6": "Saturday",
  "planning.repeat.form.title": "Custom repeat",
  "planning.repeat.form.frequency": "Repeats",
  "planning.repeat.form.daily": "Daily",
  "planning.repeat.form.weekly": "Weekly",
  "planning.repeat.form.monthly": "Monthly",
  "planning.repeat.form.every": "Every",
  "planning.repeat.form.unit.daily": "{count, plural, one {day} other {days}}",
  "planning.repeat.form.unit.weekly": "{count, plural, one {week} other {weeks}}",
  "planning.repeat.form.unit.monthly": "{count, plural, one {month} other {months}}",
  "planning.repeat.form.onDays": "On",
  "planning.repeat.form.pickDay": "Choose at least one day.",
  "planning.repeat.form.dayOfMonth": "On day",
  "planning.repeat.form.dayOfMonthHint": "Day 31 falls on the last day of shorter months.",
  "planning.repeat.form.workdaysOnly": "Move Friday and Saturday to Sunday",
  "planning.repeat.form.ends": "Ends",
  "planning.repeat.form.endsNever": "Never",
  "planning.repeat.form.endsOn": "On",
  "planning.repeat.form.endsAfter": "After",
  "planning.repeat.form.endDate": "End date",
  "planning.repeat.form.count": "Number of times",
  "planning.repeat.form.timesUnit": "{count, plural, one {time} other {times}}",
  "planning.repeat.form.save": "Save repeat",
  "planning.repeat.form.back": "Back",
  "planning.repeat.form.preview": "Preview"
}
